import { useState, createContext, lazy } from "react";
import { useTranslate, useVersion, useGetIdentity } from "react-admin";
// Components\
import { LoaderApp } from "../components/layout/LoaderApp";
import {lazyRetry} from '../utils/index';

import { useSession } from "../hooks/useSession";
const AlertModal = lazy(() => lazyRetry(() => import("../components/layout/AlertModal")));

const AppContext = createContext();

function AppProvider({ children }) {
  const { loaded, identity } = useGetIdentity();
  const translate = useTranslate();
  const version = useVersion();
  const [titleView, setTitleView] = useState("Backoffice");
  const { modalSession, setModalSession, extendSession, endSession } =
    useSession();

  const setUserBusiness = () => {
    if (loaded && identity) {
      const getLocalBusinessId =
        window.localStorage.getItem("businessIdSelected");
      if (identity.business === "0" || getLocalBusinessId !== null) {
        return getLocalBusinessId ?? "0";
      }
      return identity.business;
    }
  };

  const setUserBranch = () => {
    if (loaded && identity) {
      const getLocalBranchId = window.localStorage.getItem("branchIdSelected");
      if (identity.branch === "0" || getLocalBranchId !== null) {
        return getLocalBranchId ?? "0";
      }
      return identity.branch
    }
  };

  const value = {
    titleView,
    setTitleView,
    permissions: loaded && identity && identity.permission,
    loadedUser: loaded,
    userBusiness: setUserBusiness(),
    userBranch: setUserBranch(),
    userBranchSelected: window.localStorage.getItem("branchIdSelected")
      ? true
      : false,
    userBusinessSelected: window.localStorage.getItem("businessIdSelected")
      ? true
      : false,
    userName: loaded && identity && identity.name,
    userEmail: loaded && identity && identity.email,
    version,
  };

  return (
    <AppContext.Provider value={value}>
      {loaded ? children : <LoaderApp />}
      <AlertModal
        openAlert={modalSession}
        setOpenAlert={setModalSession}
        titleModal={translate("ra.message.time_logout")}
        handleConfirm={() => extendSession()}
        handleClose={() => endSession()}
        textConfirm={translate("ra.action.extend")}
        textCancel={translate("ra.action.close")}
      />
    </AppContext.Provider>
  );
}

export { AppProvider, AppContext };
